export const Email = {
    computed: {
        email: {
            get() {
                return this.$store.state.email
            },
            set(value) {
                this.$store.commit('setEmail', value)
            }
        },
        code: {
            get() {
                return this.$store.state.code
            },
            set(value) {
                this.$store.commit('setCode', value)
            }
        }
    },
    watch: {
        code(value) {
            value.length === 6 && this.$emit('applyCode', value)
        }
    },
    template: `
        <div class="form" v-if="this.$store.state.step === 'initial'">
            <div class="form-group form-control">
                <input type="email" placeholder=" " id="form_auth_email" v-model="email">
                <label for="form_auth_email">Email</label>
                <div v-if="this.$store.state.errors.email" class='error-tooltip'>{{this.$store.state.errors.email}}</div>
            </div>
            <div class="form-group form-buttons form-buttons--column">
                <span v-bind:class="{'button': true, 'button-load': this.$store.state.loading === true}" @click="$emit('sendCode')">{{ this.$store.state.messages.requestCode }}</span>
            </div>
            <div class="licence">
                <span v-html="this.$store.state.messages.agreement"></span><a href="${window.siteDir || '/'}licenses/" class="underlined hover" target="_blank">{{ this.$store.state.messages.privacy }}</a><span v-html="this.$store.state.messages.agreementAnd"></span><a href="${window.siteDir || '/'}licenses/terms/" class="underlined hover" target="_blank">{{ this.$store.state.messages.terms }}</a>
            </div>
        </div>
        <div class="form" v-if="this.$store.state.step === 'code'">
            <div v-bind:class="{'form-group': true, 'form-control': true, 'form-control--loading': this.$store.state.loading === true}">
                <input type="text" placeholder=" " id="form_auth_code" maxlength="6" v-model="code" :readonly="this.$store.state.loading === true">
                <label for="form_auth_code">{{ this.$store.state.messages.codeLabel }}</label>
                <div v-if="this.$store.state.errors.code" class='error-tooltip'>{{this.$store.state.errors.code}}</div>
            </div>
            <div class="form-group form-code">
                <div class="form-code__waiting" v-if="this.$store.state.timer > 0">
                    <span v-html="this.$store.state.messages.codeWaiting"></span><span
                            class="form-code__timer">{{this.$store.state.timer}}</span><span v-html="this.$store.state.messages.seconds"></span>
                </div>
                <div class="form-code__repeat hover" v-if="this.$store.state.timer === 0" @click="$emit('sendCode')">
                    {{ this.$store.state.messages.resend }}
                </div>
            </div>
        </div>
    `
}
